export default {
      id: "mail-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }